import { render, staticRenderFns } from "./bonusrules.vue?vue&type=template&id=2c189a7b&scoped=true&"
import script from "./bonusrules.vue?vue&type=script&lang=js&"
export * from "./bonusrules.vue?vue&type=script&lang=js&"
import style0 from "./bonusrules.vue?vue&type=style&index=0&id=2c189a7b&prod&lang=less&scoped=true&"
import style1 from "./bonusrules.vue?vue&type=style&index=1&id=2c189a7b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c189a7b",
  null
  
)

export default component.exports